module.exports = __webpack_public_path__ + "static_pc/img/6.facdf379.png";